// import external dependencies
import 'jquery';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faFacebookSquare, faTwitter, faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons'
//import { fas } from '@fortawesome/pro-solid-svg-icons'
import { faAngleRight  } from '@fortawesome/pro-regular-svg-icons'
//import { fal } from '@fortawesome/pro-light-svg-icons'

// Add all icons to the library so you can use it in your page
library.add(faFacebookSquare, faTwitter, faLinkedin, faInstagram, faAngleRight)

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();


// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  home,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js